import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Patterns from '../../../../../../utils/pattern/patterns';
import ThemeProvider from '../../../../../paymentJourneyRedesign/muiTheme/ThemeProvider';
import FormContainer from '../../../../../paymentJourneyRedesign/shared/formElements/FormContainer';
import CallToAction from '../../../../../shared/CallToAction/CallToAction';
import TextField from '../../../../../paymentJourneyRedesign/shared/formElements/TextField';
import CheckboxField from '../../../../../paymentJourneyRedesign/shared/formElements/CheckboxField';
import s from './RegisterForm.module.scss';
import FormError from '../FormError';
import { transformServerToFormErrors } from '../utils/transformToFormErrors';

const formFieldsMap = {
  email: 'profile.email',
};

export default function RegisterForm(props) {
  const {
    onSubmit,
    onCountryChange,
    adHocQuestionForm,
    marketingPreferencesForm,
    errorMessage,
    errors,
    children,
  } = props;

  const form = useForm({
    defaultValues: {
      shouldCreateAccount: false,
    },
  });

  const {
    watch,
    setError,
    clearErrors,
    formState: { isSubmitting },
  } = form;

  useEffect(() => {
    if (errors) {
      clearErrors();
      const transformedErrors = transformServerToFormErrors(
        errors,
        formFieldsMap,
      );

      Object.entries(transformedErrors).forEach(([key, value]) =>
        setError(key, value),
      );
    }
  }, [errors, setError, clearErrors]);

  const shouldCreateAccount = watch('shouldCreateAccount');
  const selectedCountry = watch('adHocAnswers.profile.country');

  useEffect(() => {
    if (selectedCountry) {
      onCountryChange(selectedCountry);
    }
  }, [onCountryChange, selectedCountry]);

  return (
    <ThemeProvider>
      <FormContainer form={form} onSubmit={onSubmit}>
        {children}
        {adHocQuestionForm}
        <div hidden>
          <TextField type="text" name="company" label="Company" />
        </div>
        <TextField
          type="email"
          name="profile.email"
          label="Business Email"
          rules={{ required: true }}
          sx={{ mb: 2 }}
        />
        {shouldCreateAccount && (
          <TextField
            type="password"
            name="profile.password"
            label="Password"
            rules={{
              required: true,
              minLength: {
                value: Patterns.passwordLength,
                message: `Your password must be at least ${Patterns.passwordLength} characters long`,
              },
              validate: {
                isValid(value) {
                  return !value || Patterns.isPassword(value)
                    ? true
                    : 'Password must have at least 1 upper case letter, 1 lowercase letter and 1 number';
                },
              },
            }}
            sx={{ mb: 2 }}
          />
        )}
        {selectedCountry && marketingPreferencesForm}
        <div className={s.checkbox}>
          <CheckboxField
            name="shouldCreateAccount"
            label="Create an account so you don't need to fill the form next time."
            sx={{ mt: 1 }}
          />
        </div>
        <FormError>{errorMessage}</FormError>
        <CallToAction
          type="submit"
          look="primary"
          disabled={isSubmitting}
          className={s.button}
        >
          {shouldCreateAccount
            ? 'Download & Create an Account'
            : 'Download Now'}
        </CallToAction>
      </FormContainer>
    </ThemeProvider>
  );
}
